export function animationInIfVisible(config) {
  const { root, threshold } = config;
  let { elements } = config;

  const options = {
    root: root ? root : null,
    threshold: threshold ? threshold : 0.2,
    rootMargin: "-20px",
  };

  if (!elements) {
    elements = [];
  }

  elements.forEach((element) => {
    element.classList.add("animation-in");
  });

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        addAnimation(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  elements.forEach((element) => {
    observer.observe(element);
  });
}

function addAnimation(elm) {
  if (elm.classList.contains("element-is-in")) return;
  //odczytanie ustawien
  var $data_anim_delay = elm.getAttribute("data-anim-delay");
  if ($data_anim_delay == "" || $data_anim_delay == undefined) {
    $data_anim_delay = 0;
  }

  setTimeout(function () {
    elm.classList.add("element-is-in");
    //elm.classList.remove("animation-in");
    elm.classList.remove("animation-in-observer");
  }, $data_anim_delay);
}
